/*
 * art-mega-panel — macht aus Horizons Mega-Menü das Panel aus dem Entwurf:
 * links eine Intro-Karte zur Kategorie, rechts die Produktliste mit einer Unterzeile
 * (Grammatur und Preis). Opt-in über die Theme-Einstellung „Mega-Menü: Panel (art)".
 *
 * Warum ein EIGENES Skript neben `art-mega-menu.js`: das dekoriert dieselben Elemente mit
 * Farbpunkten und läuft in einem Shop, der live verkauft. Wer dessen Verhalten anfasst, ändert
 * dort das Menü mit — deshalb liegt das Panel daneben statt darin.
 *
 * Die DATEN kommen aus Liquid (`#art-mega-panel-data`, JSON): ein Asset erreicht weder
 * Metafelder noch Sprachdateien. Verschlüsselt wird nach `href` — das ist der einzige Wert,
 * der im DOM und in Liquid derselbe ist.
 *
 * Ohne Daten oder ohne JavaScript passiert nichts: Horizons Menü bleibt, wie es ist.
 */
(() => {
  const el = document.getElementById('art-mega-panel-data');
  if (!el) return;

  let DATA;
  try {
    DATA = JSON.parse(el.textContent || '{}');
  } catch (e) {
    return;
  }
  const CATS = DATA.cats || {};
  const PRODS = DATA.prods || {};
  if (!Object.keys(CATS).length && !Object.keys(PRODS).length) return;

  /** Wem gehört ein Panel? Dem obersten Menüpunkt, in dessen Listenelement es steckt. */
  function ownerHref(panel) {
    const li = panel.closest('li');
    const a = li && li.querySelector('a[href]');
    return a ? a.getAttribute('href') : null;
  }

  function introCard(cat) {
    const box = document.createElement('div');
    box.className = 'art-mp__intro';

    if (cat.kicker) {
      const k = document.createElement('div');
      k.className = 'art-mp__kicker';
      k.textContent = cat.kicker;
      box.appendChild(k);
    }
    if (cat.title) {
      const t = document.createElement('div');
      t.className = 'art-mp__title';
      t.textContent = cat.title;
      box.appendChild(t);
    }
    if (cat.lead) {
      const p = document.createElement('p');
      p.className = 'art-mp__lead';
      p.textContent = cat.lead;
      box.appendChild(p);
    }
    if (cat.linkLabel && cat.href) {
      const a = document.createElement('a');
      a.className = 'art-mp__link';
      a.href = cat.href;
      a.textContent = cat.linkLabel;
      box.appendChild(a);
    }
    return box.children.length ? box : null;
  }

  function decorate(panel) {
    if (panel.dataset.artMp) return;
    const grid = panel.querySelector('.mega-menu__grid');
    if (!grid) return;
    panel.dataset.artMp = '1';

    /* Unterzeile je Produktlink. Der Text ist in Liquid fertig gebaut — hier steht bewusst
       keine Formatierung, sonst gäbe es zwei Orte für dieselbe Preisregel. */
    for (const a of panel.querySelectorAll('a[href]')) {
      const sub = PRODS[a.getAttribute('href')];
      if (!sub || a.querySelector('.art-mp__sub')) continue;
      const label = document.createElement('span');
      label.className = 'art-mp__name';
      // Den vorhandenen Text in ein eigenes Element heben, damit die Unterzeile darunter passt.
      while (a.firstChild) label.appendChild(a.firstChild);
      const s = document.createElement('span');
      s.className = 'art-mp__sub';
      s.textContent = sub;
      a.appendChild(label);
      a.appendChild(s);
      a.classList.add('art-mp__item');
    }

    const cat = CATS[ownerHref(panel)];
    if (!cat) return;
    const card = introCard(cat);
    if (!card) return;
    grid.insertBefore(card, grid.firstChild);
    grid.classList.add('art-mp__grid');
  }

  const scan = () => document.querySelectorAll('.mega-menu').forEach(decorate);

  scan();
  /* Horizon rendert Menü-Teile teils verzögert (und der Theme-Editor lädt Sektionen neu).
     Kurz nachlaufen und beim ersten Anfassen des Kopfes noch einmal — dann von selbst ruhig. */
  let tries = 0;
  const timer = setInterval(() => {
    scan();
    if (++tries > 10) clearInterval(timer);
  }, 300);
  document.addEventListener('shopify:section:load', scan);
  const header = document.querySelector('header, #header-component');
  if (header) {
    header.addEventListener('pointerover', scan, { once: true });
    header.addEventListener('focusin', scan, { once: true });
  }
})();
